module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/expenses/expenses.component.html
// module id = 1245
// module chunks = 0